var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInlineLockup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 278.27 78.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #20292d;\n      }\n\n      .cls-2 {\n        fill: #007896;\n      }\n\n      .cls-3 {\n        fill: #008779;\n      }\n\n      .cls-4 {\n        fill: #e5be20;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "89.19 50.08 100.86 50.08 100.86 44.4 89.19 44.4 89.19 34.78 104.49 34.78 104.49 29.1 81.78 29.1 81.78 65.8 89.19 65.8 89.19 50.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.49,41.82V36.67h-7.41V65.8h7.41V51.18q0-4.05,1.69-5.7a6.8,6.8,0,0,1,5-1.66H153V36.25Q147.45,36.25,144.49,41.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.64,36.25a11.47,11.47,0,0,0-6,1.58,11.31,11.31,0,0,0-4.18,4.31,10.2,10.2,0,0,0-4-4.36,11.42,11.42,0,0,0-5.91-1.53q-6.26,0-9,4.79V36.67H156.1V65.8h7.42V49.71a7.18,7.18,0,0,1,1.76-5.23A6.32,6.32,0,0,1,170,42.67a6.25,6.25,0,0,1,4.73,1.81,7.3,7.3,0,0,1,1.73,5.23V65.8h7.36V49.71a7.22,7.22,0,0,1,1.76-5.23,6.33,6.33,0,0,1,4.76-1.81,6.22,6.22,0,0,1,4.73,1.81,7.26,7.26,0,0,1,1.74,5.23V65.8h7.36V48.66q0-5.89-3.18-9.15A11.21,11.21,0,0,0,192.64,36.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "230.5 44.4 214.73 44.4 214.73 29.1 207.31 29.1 207.31 65.8 214.73 65.8 214.73 50.08 230.5 50.08 230.5 65.8 237.91 65.8 237.91 29.1 230.5 29.1 230.5 44.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.93,36.3,34.81,60.42a7.9,7.9,0,0,0-2.39,5.78v12A30.6,30.6,0,0,0,60.26,40.24,28.15,28.15,0,0,0,58.93,36.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.76,19.32l-13.95,14a7.88,7.88,0,0,0-2.39,5.77V57.63L57.29,32.75A99.47,99.47,0,0,0,48.76,19.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.42,0V30.48L46.53,16.36A204,204,0,0,0,32.42,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.75,30.48V0a208.36,208.36,0,0,0-14,16.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.49,19.41A106.72,106.72,0,0,0,3.88,32.76L28.75,57.63V39.05a7.88,7.88,0,0,0-2.39-5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.21,36.28c-.34.83-.63,1.63-.86,2.38a30.6,30.6,0,0,0,27.4,39.53v-12a7.9,7.9,0,0,0-2.39-5.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.63,41.19a10.2,10.2,0,0,0-9.15-4.94,12.9,12.9,0,0,0-9.88,4.18,15.13,15.13,0,0,0-3.89,10.75A15.28,15.28,0,0,0,107.62,62a12.81,12.81,0,0,0,9.81,4.23,10.32,10.32,0,0,0,9.2-5.31V65.8H134V36.67h-7.36Zm-2.31,16.33a7.45,7.45,0,0,1-10.78,0,8.49,8.49,0,0,1-2.32-6.31,8.4,8.4,0,0,1,2.29-6.25,7.41,7.41,0,0,1,5.39-2.26A7.49,7.49,0,0,1,124.32,45a8.46,8.46,0,0,1,2.31,6.29A8.45,8.45,0,0,1,124.32,57.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.53,28.58a18.4,18.4,0,0,0-13.36,5.31,18.05,18.05,0,0,0-5.44,13.48,18.1,18.1,0,0,0,5.42,13.49,18.33,18.33,0,0,0,13.35,5.31c.42,0,.84,0,1.26,0l.94-.08.19,0c.67-.09,1.35-.22,2-.37a15.81,15.81,0,0,0,12.27,5.88v-7.7a8.05,8.05,0,0,1-4.88-1.66,17.68,17.68,0,0,0,4.94-6,18.53,18.53,0,0,0,1.08-2.66c.11-.34.21-.68.3-1a20.37,20.37,0,0,0,.64-5.13,18,18,0,0,0-5.41-13.46A18.31,18.31,0,0,0,259.53,28.58ZM267.6,56.1a11.64,11.64,0,0,1-16.22,0,12.12,12.12,0,0,1-3.13-8.73,12.12,12.12,0,0,1,3.13-8.73,11.69,11.69,0,0,1,16.22,0,12.12,12.12,0,0,1,3.1,8.73A12.22,12.22,0,0,1,267.6,56.1Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInlineLockup);
export default __webpack_public_path__ + "static/media/inlineLockup.2147243e.svg";
export { ForwardRef as ReactComponent };